@if( project ) {
<p>You can show the stats for a whole canon in your project, or for just one book.</p>

<mat-form-field>
    <mat-label>Show the stats for...</mat-label>
    <mat-select [formControl]="scopeControl">
      @for( c of project.canons; track c ) {
        <mat-option [value]="c">{{c}}</mat-option>
      }
      @for( c of project.canons; track c ) {
        <mat-optgroup [label]="c + ' Books'">
          @for (book of canonBooks(c); track book) {
            <mat-option [value]="makeBookIdentifier(c,book)">{{project.bookNames.get(book)}}</mat-option>
          }
        </mat-optgroup>
      }
    </mat-select>
  </mat-form-field>

@if( lexicalItemData ) {
<p class="caption">This shows the number of lexical items that you have provided glosses for.</p>
<canvas baseChart [data]="lexicalItemData" [options]="pieChartOptions" [type]="pieChartType"> </canvas>
}

@if( wordData ) {
<p class="caption">This shows the number of words that have glosses and votes. Words that only need votes are those for which all you need to do is vote on a gloss that's already available!</p>
<canvas baseChart [data]="wordData" [options]="pieChartOptions" [type]="pieChartType"> </canvas>
}

<div id="footer"></div>
}